import React, {useEffect} from "react";
import {Col, Row} from "antd";
import {observer} from "mobx-react-lite";
import {useHistory} from "react-router-dom";
import {CustomerMenuHeader} from "components/layouts/customerLayout/components/customerMenuHeader";
import {CustomerFluidSubPageLayout} from "components/layouts/customerLayout/customerFluidSubPageLayout/CustomerFluidSubPageLayout";
import {AnnouncementRow} from "../customerHomePage/announcementRow/AnnouncementRow";
import {CustomerHomeMapComponent} from "../customerHomePageWithShiftScore/components/CustomerHomeMapComponent";
import {
    CustomerHomePageButtonContainer,
    CustomerHomePageMapContainer,
    CustomerNavigationContainer
} from "../customerHomePageWithShiftScore/CustomerHomePageWithShiftScore.styles";
import {useStore} from "hooks/useStore";
import {isDedicatedIntegrationCustomer} from "utils/customerHelpers";
import {CUSTOMER_SHIFTS_TABS} from "constants/constants";
import useCustomerShiftsPage from "./hooks/useCustomerShiftsPage";
import ShiftsNavigationButtons from "./components/ShiftsNavigationButtons";
import ActiveShiftsTab from "./components/ActiveShiftsTab";
import PlannedShiftsTab from "./components/PlannedShiftsTab";
import CompletedShiftsTab from "./components/CompletedShiftsTab";
import {PageContent, TabContentSection} from "./styles/CustomerShiftsPage.styles";

const CustomerShiftsPage = observer(() => {
    const stores = useStore();
    const history = useHistory();
    const isDedicatedIntegration = isDedicatedIntegrationCustomer(stores?.meStore);
    const selectedSubCompanyId = stores?.meStore?.selectedSubCompanyId;

    const {
        tabKey,
        changeTab,
        shiftCounts,
        activeCurrentPage,
        setActiveCurrentPage,
        plannedCurrentPage,
        setPlannedCurrentPage,
        completedCurrentPage,
        setCompletedCurrentPage,
        completedFilters,
        setCompletedFilters,
        plannedFilters,
        setPlannedFilters,
        activeTab,
        plannedTab,
        completedTab
    } = useCustomerShiftsPage({
        poolShiftStore: stores.poolShiftStore,
        selectedSubCompanyId,
        isDedicatedIntegration
    });

    useEffect(() => {
        if (!isDedicatedIntegration) {
            history.replace("/musteri");
        }
    }, [isDedicatedIntegration, history]);

    if (!isDedicatedIntegration) {
        return null;
    }

    return (
        <CustomerFluidSubPageLayout>
            <CustomerMenuHeader />
            <Row style={{width: "100%", padding: "0"}}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <AnnouncementRow />
                </Col>
            </Row>
            <PageContent>
                <CustomerHomePageButtonContainer>
                    <CustomerNavigationContainer>
                        <ShiftsNavigationButtons
                            tabKey={tabKey}
                            changeTab={changeTab}
                            shiftCounts={shiftCounts}
                        />
                    </CustomerNavigationContainer>
                    <CustomerHomePageMapContainer>
                        <CustomerHomeMapComponent
                            selectedSubCompanyId={selectedSubCompanyId || ""}
                        />
                    </CustomerHomePageMapContainer>
                </CustomerHomePageButtonContainer>

                <TabContentSection>
                    {tabKey === CUSTOMER_SHIFTS_TABS.ACTIVE && (
                        <ActiveShiftsTab
                            data={activeTab.data}
                            loading={activeTab.loading}
                            currentPage={activeCurrentPage}
                            setCurrentPage={setActiveCurrentPage}
                        />
                    )}
                    {tabKey === CUSTOMER_SHIFTS_TABS.PLANNED && (
                        <PlannedShiftsTab
                            filters={plannedFilters}
                            setFilters={setPlannedFilters}
                            currentPage={plannedCurrentPage}
                            setCurrentPage={setPlannedCurrentPage}
                            loading={plannedTab.loading}
                            data={plannedTab.data}
                        />
                    )}
                    {tabKey === CUSTOMER_SHIFTS_TABS.COMPLETED && (
                        <CompletedShiftsTab
                            filters={completedFilters}
                            setFilters={setCompletedFilters}
                            currentPage={completedCurrentPage}
                            setCurrentPage={setCompletedCurrentPage}
                            loading={completedTab.loading}
                            data={completedTab.data}
                        />
                    )}
                </TabContentSection>
            </PageContent>
        </CustomerFluidSubPageLayout>
    );
});

export default CustomerShiftsPage;
